import API from "./API";

const ProjectSPService = {
  async getParticularProjectSP(ProjectSP_id: number) {
    const response = await API().get("ProjectSP/" + ProjectSP_id, {
      method: "GET",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    });
    return response.data[0];
  },
};

export default ProjectSPService;
